import { NgModule } from '@angular/core';

import { AgentNetworkIcon } from './agent-network-icon.component';
import { AlertCircleIcon } from './alert-circle-icon.component';
import { ArrowRightIcon } from './arrow-right-icon.component';
import { CheckCircleIcon } from './check-circle-icon.component';
import { CheckCircleOutlineIcon } from './check-circle-outline-icon.component';
import { ChevronLeftIcon } from './chevron-left-icon.component';
import { ChevronUpIcon } from './chevron-up-icon.component';
import { CopyIcon } from './copy-icon.component';
import { CrossIcon } from './cross-icon.component';
import { DotsIcon } from './dots-icon.component';
import { DoubleChevronIcon } from './double-chevron-icon.component';
import { DownloadCloudIcon } from './download-cloud-icon.component';
import { DownloadIcon } from './download-icon.component';
import { ExternalLinkIcon } from './external-link-icon.component';
import { EyeIcon } from './eye-icon.component';
import { FileAlternate2Icon } from './file-alternate-2.icon.component';
import { FileAlternateIcon } from './file-alternate-icon.component';
import { FileIcon } from './file-icon.component';
import { FileLinesIcon } from './file-lines-icon.component';
import { FinancialStatementIcon } from './financial-statement-icon.component';
import { FolderIcon } from './folder-icon.component';
import { LetterManagementIcon } from './letter-management-icon.component';
import { LinkIcon } from './link-icon.component';
import { LogoutIcon } from './logout-icon.component';
import { MinusIconComponent } from './minus-icon.component';
import { NoteEditIcon } from './note-edit-icon.component';
import { NotificationIcon } from './notification-icon.component';
import { PauseIcon } from './pause-icon.component';
import { Pen2Icon } from './pen-2-icon.component';
import { PenIcon } from './pen-icon.component';
import { PlusIcon } from './plus-icon.component';
import { PrinterIcon } from './printer-icon.component';
import { RefreshIcon } from './refresh-icon.component';
import { SaveIcon } from './save-icon.component';
import { SearchIcon } from './search-icon.component';
import { SendIcon } from './send-icon.component';
import { Trash2Icon } from './trash-2-icon.component';
import { TrashIcon } from './trash-icon.component';
import { UploadCloudIcon } from './upload-cloud-icon.component';
import { UserIcon } from './user-icon.component';

@NgModule({
  declarations: [
    AgentNetworkIcon,
    AlertCircleIcon,
    ArrowRightIcon,
    CheckCircleIcon,
    CheckCircleOutlineIcon,
    ChevronLeftIcon,
    ChevronUpIcon,
    CopyIcon,
    CrossIcon,
    DotsIcon,
    DoubleChevronIcon,
    DownloadCloudIcon,
    DownloadIcon,
    ExternalLinkIcon,
    EyeIcon,
    FileAlternate2Icon,
    FileAlternateIcon,
    FileIcon,
    FileLinesIcon,
    FinancialStatementIcon,
    FolderIcon,
    LetterManagementIcon,
    LinkIcon,
    LogoutIcon,
    MinusIconComponent,
    NoteEditIcon,
    NotificationIcon,
    PauseIcon,
    Pen2Icon,
    PenIcon,
    PlusIcon,
    PrinterIcon,
    RefreshIcon,
    SaveIcon,
    SearchIcon,
    SendIcon,
    Trash2Icon,
    TrashIcon,
    UploadCloudIcon,
    UserIcon,
  ],
  exports: [
    AgentNetworkIcon,
    AlertCircleIcon,
    ArrowRightIcon,
    CheckCircleIcon,
    CheckCircleOutlineIcon,
    ChevronLeftIcon,
    ChevronUpIcon,
    CopyIcon,
    CrossIcon,
    DotsIcon,
    DoubleChevronIcon,
    DownloadCloudIcon,
    DownloadIcon,
    ExternalLinkIcon,
    EyeIcon,
    FileAlternate2Icon,
    FileAlternateIcon,
    FileIcon,
    FileLinesIcon,
    FinancialStatementIcon,
    FolderIcon,
    LetterManagementIcon,
    LinkIcon,
    LogoutIcon,
    MinusIconComponent,
    NoteEditIcon,
    NotificationIcon,
    PauseIcon,
    Pen2Icon,
    PenIcon,
    PlusIcon,
    PrinterIcon,
    RefreshIcon,
    SaveIcon,
    SearchIcon,
    SendIcon,
    Trash2Icon,
    TrashIcon,
    UploadCloudIcon,
    UserIcon,
  ],
})
export class IconsModule {}
